import React from 'react';
import { cn } from '@/utils/cn';

interface SliderProps {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  className?: string;
  disabled?: boolean;
}

export const Slider: React.FC<SliderProps> = ({
  min,
  max,
  step = 1,
  value,
  onChange,
  className,
  disabled = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value);
    onChange(newValue);
  };

  // Calculate percentage for styling
  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className={cn('relative', className)}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={cn(
          'w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer',
          'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          // Custom track styling
          'slider-track'
        )}
        style={{
          background: `linear-gradient(to right, rgb(59, 130, 246) 0%, rgb(59, 130, 246) ${percentage}%, rgb(229, 231, 235) ${percentage}%, rgb(229, 231, 235) 100%)`,
        }}
      />

      {/* Value display */}
      <div className="flex justify-between text-xs text-gray-500 mt-1">
        <span>{min}</span>
        <span className="font-medium text-gray-700">{value.toFixed(2)}</span>
        <span>{max}</span>
      </div>

      <style>{`
        .slider-track::-webkit-slider-thumb {
          appearance: none;
          height: 16px;
          width: 16px;
          border-radius: 50%;
          background: rgb(59, 130, 246); /* blue-500 */
          cursor: pointer;
          border: 2px solid rgb(255, 255, 255);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .slider-track::-moz-range-thumb {
          height: 16px;
          width: 16px;
          border-radius: 50%;
          background: rgb(59, 130, 246); /* blue-500 */
          cursor: pointer;
          border: 2px solid rgb(255, 255, 255);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .slider-track:disabled::-webkit-slider-thumb {
          background: rgb(156, 163, 175); /* gray-400 */
          cursor: not-allowed;
        }

        .slider-track:disabled::-moz-range-thumb {
          background: rgb(156, 163, 175); /* gray-400 */
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};